import homeReducer from "./reducers";
export { default as homeOperations } from "./operations";

export default homeReducer;
